import type { Dispatch, SetStateAction } from 'react';

export enum TableCellContentType {
  DND = 'DND',
  CHECKBOX = 'CHECKBOX',
  ACTION = 'ACTION',
  LOADING = 'LOADING',
  NO_PADDING = 'NO_PADDING',
}

export interface Option<T> {
  label: string;
  value: T;
}

export interface PageDetails {
  from: number;
  to: number;
  total: number;
}

export interface PaginationDetails {
  page: number;
  setPage: Dispatch<SetStateAction<number>>;
  perPage: number;
  setPerPage: Dispatch<SetStateAction<number>>;
}
